/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import WalletListIcon from '../../../icons/WalletListIcon';
import { FundsType, Master } from '../../../types/masterTypes';
import { applyStyles } from '../../../utils/applyStyles';
import { setMasterFundsMenuStatus } from '../../../redux/actions/setMobileMenusStatus';
import { setChosenFundsType } from '../../../redux/actions/master/setChosenFundsType';
import styles from './UserMenuMobile.module.css';
import { PAMMState } from '../../../redux/reducers/rootReducer';

const MasterFundsMenuMobile: React.FC<any> = ({ onSwipe, onCancel }): JSX.Element => {
  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showMasterFundsMenu);
  const master: Master = useSelector((state: PAMMState) => state.masterReducer.master);

  const [chosenSource, setChosenSource] = React.useState<FundsType>(FundsType.TotalFunds);

  const dispatch = useDispatch();

  const handleSelectMasterFundsAccount = (id: FundsType): void => {
    setChosenSource(id);
    dispatch(setMasterFundsMenuStatus(false));
    localStorage.setItem('linkedIdMobile', master.OwnFunds.Id.toString());

    if (id === FundsType.TotalFunds) {
      dispatch(setChosenFundsType(FundsType.TotalFunds));
    } else {
      dispatch(setChosenFundsType(FundsType.OwnFunds));
    }
  };

  return (
    <div
      id="master-funds-menu"
      className={applyStyles([styles['menu'], show ? styles['show'] : styles['hide']])}
      onPointerMove={(event) => onSwipe(event)}
      onPointerCancel={() => onCancel('masterFundsMenu')}
    >
      <div className={applyStyles([styles['header'], 'text-h4-semibold'])}>
        <FormattedMessage id="chooseAccount" />
      </div>

      <div className={styles['account-list']}>
        {[
          { id: FundsType.TotalFunds, name: 'button.totalMasterFunds' },
          { id: FundsType.OwnFunds, name: 'button.ownFunds' }
        ].map((option) => {
          const isActive = chosenSource === option.id;

          return (
            <div key={option.id} className={styles['account-item']} onClick={() => handleSelectMasterFundsAccount(option.id)}>
              <div className={`${styles['indicator']} ${isActive ? styles['active'] : ''}`} />
              <span className={applyStyles([styles['icon'], isActive ? styles['active'] : ''])}>
                <WalletListIcon />
              </span>
              <div className="text-regular d-flex">
                <span
                  className={applyStyles([styles['account-name'], 'text-h4', 'truncate-name', isActive ? styles['active'] : ''])}
                >
                  {option.id === FundsType.TotalFunds ? master?.Name : <FormattedMessage id={option.name} />}
                </span>
                <span className={styles['account-id']}>
                  (<FormattedMessage id="id" />:{option.id === FundsType.TotalFunds ? master?.Id : master?.OwnFunds?.Id})
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default MasterFundsMenuMobile;
